import { useAuth } from "@/context/AuthContext";
import React, { useEffect } from "react";
import { initPush } from "@/lib/push";
import { Navigate, useLocation } from "react-router-dom";
import { Header } from "@/components/layouts/header";
import { Footer } from "@/components/layouts/footer";
import { Content } from "@/components/layouts/content";
import ContactButton from "./contact/ContactButton";
import { usePlatform } from "@/hooks/usePlatform";
import { APP_BAR_TOTAL, MobileAppBar, MobileTabBar, TAB_BAR_HEIGHT } from "@/components/mobile/MobileShell";

export const ProtectedRoute = () => {
    const { isAuth, api } = useAuth();

    const location = useLocation();

    const { isMobile, platform } = usePlatform();

    // Push мэдэгдэл — нэвтэрсэн хойно нэг удаа. Зөвшөөрөл авч, OS-ээс ирсэн
    // токеныг backend-д бүртгэнэ (ad030401). Вэб дээр initPush нь шууд буцна.
    useEffect(() => {
        if (!isAuth()) return;
        initPush({
            onToken: (token) => {
                if (!token) return;
                api("ad030401", { token, platform }).catch((e) =>
                    console.error("[push] токен бүртгэх амжилтгүй", e)
                );
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isAuth()) {
        return <Navigate to={"/login"} replace />;
    }

    // ---- Мобайл (native) бүрхүүл ----
    // Дээд AppBar + доод таб самбар. Вэбийн Header/Footer/ContactButton-ыг
    // харуулахгүй — тэдгээр нь вэб хуудасны мэдрэмж өгдөг.
    if (isMobile) {
        return (
            <div className="melp-native" style={{ minHeight: "100vh", background: "#f7f8fa" }}>
                <MobileAppBar />
                <div
                    style={{
                        // AppBar нь дээд аюулгүй бүсийг мөн бүрхдэг тул түүний
                        // БҮТЭН өндрөөр зай авна.
                        paddingTop: APP_BAR_TOTAL,
                        // Таб самбар + home indicator + сүүлийн товч самбарт наалдахгүй
                        // амьсгалах зай (24px).
                        paddingBottom: `calc(${TAB_BAR_HEIGHT}px + env(safe-area-inset-bottom) + 24px)`,
                    }}
                >
                    <Content />
                </div>
                <MobileTabBar />
            </div>
        );
    }

    // ---- Вэб (хэвээрээ) ----
    return (
        <div className='h-screen'>
            <Header />
            <div className='overflow-y-auto' style={{ backgroundColor: location.pathname === '/dashboard' ? '#f9f9f9' : '' }}>
                <div className="absolute bottom-10 right-6 z-50">
                    <ContactButton/>
                </div>
                <Content />
            </div>
            <Footer />
        </div>
    );
};
